import Vue from 'vue'
import axios from 'axios'
import store from '../store/index'

const service = axios.create({
    baseURL: process.env.API_ROOT,
    timeout: 5000000,
    withCredentials: true  // 始终发送 cookies
})

// 防止重复跳转的标志
let isRedirecting = false

// 处理未登录的统一方法
function handleNotAuthenticated() {
    // 避免重复跳转
    if (isRedirecting) return
    isRedirecting = true

    // 清除用户信息
    store.commit('setUserInfo', {})
    localStorage.removeItem('token')
    localStorage.removeItem('userInfo')

    // 显示提示
    Vue.prototype.$message({
        message: 'Login expired, please login again',
        type: 'warning',
        duration: 2000
    })

    // 强制跳转到登录页（使用绝对路径 + replace）
    const loginUrl = window.location.protocol + '//' + window.location.host + '/#/login'

    // 如果当前不在登录页，执行跳转
    if (window.location.hash !== '#/login' && !window.location.hash.includes('#/login?')) {
        window.location.replace(loginUrl)
    }

    // 重置标志
    setTimeout(() => {
        isRedirecting = false
    }, 3000)
}

service.interceptors.request.use(config => {
    const token = localStorage.getItem('token')
    if (token) {
        config.headers['Authorization'] = `Bearer ${token}`
    }
    return config
}, error => {
    return Promise.reject(error)
})

service.interceptors.response.use(
    response => {
        // 检查 code: 4001 (未登录)
        if (response.data && response.data.code == 4001) {
            handleNotAuthenticated()
            return Promise.reject(new Error('Not authenticated'))
        }
        return response.data
    },
    error => {
        // 检查 HTTP 401 状态码
        if (error.response && error.response.status === 401) {
            handleNotAuthenticated()
            return Promise.reject(error)
        }
        return Promise.reject(error)
    }
)

export {
    service as axios
}
